module.exports = __webpack_public_path__ + "static/media/GuideSuyo.abd3eb78.png";